/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum MediaFormat {
  MANGA = 'MANGA',
  MOVIE = 'MOVIE',
  MUSIC = 'MUSIC',
  NOVEL = 'NOVEL',
  ONA = 'ONA',
  ONE_SHOT = 'ONE_SHOT',
  OVA = 'OVA',
  SPECIAL = 'SPECIAL',
  TV = 'TV',
  TV_SHORT = 'TV_SHORT',
}

export enum MediaType {
  ANIME = 'ANIME',
  MANGA = 'MANGA',
}

/**
 * A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.
 */
export enum __DirectiveLocation {
  ARGUMENT_DEFINITION = 'ARGUMENT_DEFINITION',
  ENUM = 'ENUM',
  ENUM_VALUE = 'ENUM_VALUE',
  FIELD = 'FIELD',
  FIELD_DEFINITION = 'FIELD_DEFINITION',
  FRAGMENT_DEFINITION = 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD = 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT = 'INLINE_FRAGMENT',
  INPUT_FIELD_DEFINITION = 'INPUT_FIELD_DEFINITION',
  INPUT_OBJECT = 'INPUT_OBJECT',
  INTERFACE = 'INTERFACE',
  MUTATION = 'MUTATION',
  OBJECT = 'OBJECT',
  QUERY = 'QUERY',
  SCALAR = 'SCALAR',
  SCHEMA = 'SCHEMA',
  SUBSCRIPTION = 'SUBSCRIPTION',
  UNION = 'UNION',
  VARIABLE_DEFINITION = 'VARIABLE_DEFINITION',
}

/**
 * An enum describing what kind of type a given `__Type` is.
 */
export enum __TypeKind {
  ENUM = 'ENUM',
  INPUT_OBJECT = 'INPUT_OBJECT',
  INTERFACE = 'INTERFACE',
  LIST = 'LIST',
  NON_NULL = 'NON_NULL',
  OBJECT = 'OBJECT',
  SCALAR = 'SCALAR',
  UNION = 'UNION',
}

//==============================================================
// END Enums and Input Objects
//==============================================================
